<div class="onboarding-container">
  <h2>Welcome to WhatNow, <span class="business-details">{{ business }}</span>!</h2>

  <!-- Loading Indicator -->
  <div *ngIf="isCheckingDraft" class="loading-message">
    <p>Checking for existing progress...</p>
    <div class="spinner"></div>
  </div>

  <!-- Draft Data Message -->
  <div *ngIf="!isCheckingDraft && hasDraft" class="draft-message">
    <p>You have draft data saved. Would you like to continue onboarding?</p>
    <div class="button-group">
      <button (click)="cancel()" class="start-btn cancel-btn">Cancel</button>
      <button (click)="continueOnboarding()" class="start-btn">Continue Onboarding</button>
    </div>
  </div>

  <!-- Start Onboarding Form -->
  <div *ngIf="!isCheckingDraft && !hasDraft" class="form-group">
    <strong>Confirm Business Details</strong>
    <p>Verify or update your details below to start onboarding.</p>
    <label for="businessName">Business Name</label>
    <input
      type="text"
      id="businessName"
      [(ngModel)]="business"
      placeholder="Enter your business name"
      class="input-field"
      required
    />
    <label for="email">Email</label>
    <input
      type="email"
      id="email"
      [(ngModel)]="email"
      placeholder="Enter your email"
      class="input-field"
      required
      disabled
    />
    <label for="contact">Contact</label>
    <input
      type="text"
      id="contact"
      [(ngModel)]="contact"
      placeholder="Enter your contact number"
      class="input-field"
      required
    />
    <div class="button-group">
      <button (click)="cancel()" class="start-btn cancel-btn">Cancel</button>
      <button (click)="startOnboarding()" class="start-btn" [disabled]="isLoading || !customerId || !email || hasDraft">
        <span *ngIf="isLoading" class="spinner"></span>
        <span>{{ isLoading ? 'Loading...' : 'Start Onboarding' }}</span>
      </button>
    </div>
  </div>
</div>